'use client';

import { AppMode } from "@habity/types";
import React, { cloneElement, ReactElement } from "react";
import { useModeChange } from "~/hooks/useModeChange";

interface OnClickModeChangeProps {
  mode: AppMode,
  children?: React.ReactNode;
}

export function OnClickModeChange({ mode, children }: OnClickModeChangeProps) {
  const { changeMode } = useModeChange();

  return React.Children.map(children, (child) =>
    cloneElement(child as ReactElement<{ onClick?: () => void }>, {
      onClick: () => changeMode(mode),
    })
  );
}
